import { autorun } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react'
import { uploadImage } from '../../../services/ElementService';
import { ReactComponent as TrashIcon } from "../../../svg/delete-icon.svg";
import { ReactComponent as CropIcon } from "../../../svg/crop-icon.svg";
import ColorPicker from "../../ColorPicker/ColorPicker"
import ColorBlock from '../../Inputs/ColorBlock';
import Upload from '../../Inputs/Upload';

@inject('templateStore', 'sidebarStore', 'store', 'workAreaStore', 'errorStore') @observer
class ColorSlide extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      uploadAllowed: false,
      uploading: false,
      existingBackgound: null,
      transparent: false,
      progress: 0,
      defaultColors: [
        {
          color: '#F44236',
          selected: false
        },
        {
          color: '#EA1E63',
          selected: false
        },
        {
          color: '#9C28AF',
          selected: false
        },
        {
          color: '#673BB7',
          selected: false
        },
        {
          color: '#3F51B5',
          selected: false
        },
        {
          color: '#2196F3',
          selected: false
        },

        {
          color: '#00BCD5',
          selected: false
        },
        {
          color: '#009788',
          selected: false
        },
        {
          color: '#4CAF52',
          selected: false
        },
        {
          color: '#8BC24A',
          selected: false
        },
        {
          color: '#CDDC39',
          selected: false
        },
        {
          color: '#FFEA3C',
          selected: false
        },

        {
          color: '#FF9700',
          selected: false
        },
        {
          color: '#FE5722',
          selected: false
        },
        {
          color: '#795549',
          selected: false
        },
        {
          color: '#9E9E9E',
          selected: false
        },
        {
          color: '#607D8B',
          selected: false
        },
        {
          color: '#353535',
          selected: false
        },
      ],
      showBrandPromo: false,
      brandColors: [],
      showPicker: true,
    }
  }

  getProps(page){
    if(!page){
      return {
        existing: null,
        showPicker: true
      }
    }
    const bg = page.backgroundUrl
    const existing = bg && bg.length ? bg : null
    const transparent = !!page.transparent
    return {
      existing,
      showPicker: true,
      transparent
    }
  }

  getDefaultColors(pageObj){
    const copy = [...this.state.defaultColors].map(color => {
      if(color.color === pageObj.background.toLowerCase()){
        color.selected = true
      }
      return color
    })
    return copy
  }

  setActiveColor(color){
    const copy = [...this.state.defaultColors]
    const hexColor = this.toHex(this.props.activeColor)
    const activeIdx = this.state.defaultColors.findIndex(({ color }) => color.toLowerCase() === hexColor.toLowerCase())
    copy.forEach(c => {
      c.selected = false
    })
    if(activeIdx > -1){
      copy[activeIdx].selected = true
    }
    this.setState({
      defaultColors: copy
    })
  }

  updateBrandPalette(){
    const brandColors = []
    this.props.workAreaStore.activeBrand.palettes.forEach(palette => {
      const obj = {
        name: palette.name,
        colors: []
      }
      palette.colors.forEach(color => {
        obj.colors.push({
          color: color,
          selected: false
        })
      })
      brandColors.push(obj)
    })
    this.setState({
      brandColors
    })
  }

  componentDidMount(){
    const { sidebarStore, workAreaStore, isSidebar } = this.props
    const page = workAreaStore.getActivePage()
    if(this.props.activeColor){
      this.setActiveColor(this.props.activeColor)
    }
    if(workAreaStore.activeBrand){
      this.updateBrandPalette()
    }
    this.setBrandPromo()
    if(sidebarStore.open && workAreaStore.activePage && !this.state.uploadAllowed){
      if(!page){
        return
      }
      const { showPicker, existing, transparent } = this.getProps(page)
      const pageObj = this.props.workAreaStore.getActivePage()
      const defaultColors = this.getDefaultColors(pageObj)
      this.setState({
        uploadAllowed: true,
        existingBackgound: existing,
        transparent,
        defaultColors,
        showPicker
      })
    }
    if(sidebarStore.open && !workAreaStore.activePage){
      const firstPage = this.props.workAreaStore.pages[0]
      this.setState({
        uploadAllowed: true,
        transparent: firstPage.transparent
      })
    }
    if(this.props.slideId === 'color-picker' || this.props.slideId === 'svg-color-picker'){
      this.setState({
        uploadAllowed: false,
        existingBackgound: null
      })
    }
  }

  setBrandPromo(){
    const { store, workAreaStore } = this.props
    if(store.auth && !workAreaStore.activeBrand){
      this.setState({ showBrandPromo: true })
    }else{
      this.setState({ showBrandPromo: false })
    }
  }

  componentToHex(c) {
    const num = Number(c)
    var hex = num.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
  }

  toHex(color){
    color = color.replace('rgba(', '').replace(')', '')
    const [r, g, b] = color.split(', ')
    return '#' + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b)
  }

  componentDidUpdate(prevProps){
    if((!prevProps.activeBrand && this.props.activeBrand) || (this.props.activeBrand && prevProps.activeBrand && prevProps.activeBrand._id !== this.props.activeBrand._id)){
      this.setBrandPromo()
      this.updateBrandPalette()
    }
    if(prevProps.activeColor !== this.props.activeColor && this.props.activeColor){
      this.setActiveColor(this.props.activeColor)
    }
    if(prevProps.activePage !== this.props.activePage || prevProps.slideId !== this.props.slideId){
      const { slideId } = this.props
      if(this.props.activePage && (slideId === 'color-picker-page' || slideId === 'background')){
        const pageObj = this.props.workAreaStore.getActivePage()
        const { showPicker, existing, transparent } = this.getProps(pageObj)
        this.setState({
          existingBackgound: existing,
          showPicker,
          transparent,
          uploadAllowed: true
        })
      }
      if(!this.props.activePage && (slideId === 'color-picker-page' || slideId === 'background')){
        //this.props.sidebarStore.changeStatus('color-picker')
        this.setState({
          existingBackgound: null,
          showPicker: true,
          transparent: false,
          uploadAllowed: true
        })
      }
    }
    if(prevProps.slideId !== 'color-picker' && this.props.slideId === 'color-picker'){
      this.setState({
        uploadAllowed: false
      })
    }
  }  
  
  setProgress(data){
    this.setState({ progress: Math.round((100 * data.loaded) / data.total) })
  }

  async uploadToServer(file){
    document.querySelector('.hidden-upload').style.display = 'none'
    const { workAreaStore, errorStore } = this.props
    this.setState({ uploading: true })
    const page = this.props.workAreaStore.getActivePage()
    try{
      const id = page ? page.id : workAreaStore.pages[0].id
      const data = await uploadImage(file, workAreaStore.designId, this.setProgress.bind(this), id, workAreaStore.activeBrand ? workAreaStore.activeBrand._id : undefined)
      this.setState({ uploading: false, progress: 0 })
      if(!page){
        let firstPage = null
        workAreaStore.pages.forEach((p, idx) => {
          if(idx === 0){
            firstPage = p.id
          }
          workAreaStore.changePageProp(p.id, 'backgroundUrl', data.url)
          workAreaStore.changePageProp(p.id, 'backgroundId', data.assetId)
          workAreaStore.setActivePage(firstPage)
        })
      }else{
        workAreaStore.changePageProp(page.id, 'backgroundUrl', data.url)
        workAreaStore.changePageProp(page.id, 'backgroundId', data.assetId)
        workAreaStore.setActivePage(page.id)
      }
      errorStore.setErrorMessage('Uploaded background image', false)
      this.setState({ existingBackgound: page ? page.backgroundUrl : workAreaStore.pages[0].backgroundUrl })
    }catch(err){
      console.log(err)
      errorStore.setErrorMessage('Failed to upload background image')
    }
  }

  deleteBackground(){
    this.props.workAreaStore.deletePageBackground()
    this.setState({ existingBackgound: null, showPicker: true })
  }

  setTransparent(){
    const { workAreaStore } = this.props
    const val = !this.state.transparent
    const page = this.props.workAreaStore.getActivePage()
    if(!page){
      workAreaStore.pages.forEach(p => {
        workAreaStore.changePageProp(p.id, 'transparent', val)
      })
    }else{
      workAreaStore.changePageProp(page.id, 'transparent', val)
    }
    this.setState(({ transparent: val }))
  }

  selectProjectColor(color, idx){
    const copy = [...this.state.brandColors]
    copy[idx].colors.map(elem => {
      if(elem.color === color){
        elem.selected = true
      }else{
        elem.selected = false
      }
      return elem
    })
    this.setState({ brandColors: copy })
    const { workAreaStore } = this.props
    const rgbaColor = this.props.workAreaStore.hexToRgba(color)
    if (workAreaStore.selectedLayer) {
      const { pageIdx, layerIdx } = workAreaStore.findLayerIdx(workAreaStore.selectedLayer)
      if(pageIdx > -1 && layerIdx > -1){
        const layer = workAreaStore.pages[pageIdx].layers[layerIdx]
        if (layer && layer.type === 'element' && !this.timer) {
            layer.fillHex = rgbaColor
            // Todo: debounce
            // this.props.workAreaStore.appendToHistory()
        }
        if(layer && layer.type === 'svgGroup'){
          this.props.workAreaStore.changeSVGGroupFill(layer.id, rgbaColor)
          return
        }
        return
      }
    }
    if(workAreaStore.activePage){
      const page = workAreaStore.getPage(workAreaStore.activePage)
      if(page){
        page.background = rgbaColor
      }
    }
    if(!workAreaStore.activePage && this.props.isSidebar){
      workAreaStore.changePagesColor(rgbaColor)
    }
  }

  selectColorFromBlock(color, obj){
    const copy = [...this.state[obj]].map(elem => {
      if(elem.color === color){
        elem.selected = true
      }else{
        elem.selected = false
      }
      return elem
    })
    const rgbaColor = this.props.workAreaStore.hexToRgba(color)
    const { workAreaStore } = this.props
    if (workAreaStore.selectedLayer) {
      const { pageIdx, layerIdx } = workAreaStore.findLayerIdx(workAreaStore.selectedLayer)
      if(pageIdx > -1 && layerIdx > -1){
        const layer = workAreaStore.pages[pageIdx].layers[layerIdx]
        if (layer && layer.type === 'element' && !this.timer) {
            layer.fillHex = rgbaColor
            // Todo: debounce
            // this.props.workAreaStore.appendToHistory()
        }
        if(layer && layer.type === 'svgGroup'){
          this.props.workAreaStore.changeSVGGroupFill(layer.id, rgbaColor)
          return
        }
        return
      }
    }
    if(workAreaStore.activeBrand){
      this.updateBrandPalette()
    }
    if(workAreaStore.activePage){
      const page = workAreaStore.getPage(workAreaStore.activePage)
      if(page){
        page.background = rgbaColor
      }
    }
    if(!workAreaStore.activePage && this.props.isSidebar){
      workAreaStore.changePagesColor(rgbaColor)
    }
    this.setState({ [obj]: copy })
  }

  openCropper(){
    this.props.workAreaStore.toggleBackgroundCropper(this.props.workAreaStore.activePage)
  }

  getBrandPromoLink(){
    return '/dashboard/brands/create' + `?redirect=${window.location.href}`
  }

  openBrandModal(e){
    e.preventDefault()
    e.stopPropagation()
    const { store } = this.props
    if(store.subscription){
      store.toggleAnyModal('projectsOpen', true)
    }else{
      store.toggleSubscriptionModal(true)
    }
  }

  render(){
    const { uploadAllowed, progress, uploading, transparent, showPicker, existingBackgound, showBrandPromo } = this.state
    const { workAreaStore, isSidebar } = this.props
    return(
      <div className="slide-wrapper">
        <div className="row no-gutters limited-size">
            {showPicker ? (
            <ColorPicker 
              isSidebar={isSidebar}
              showTransparent={showPicker && uploadAllowed} 
              transparent={transparent} 
              pageId={workAreaStore.activePage} 
              setTransparent={this.setTransparent.bind(this)}
            />
            ) : undefined}
            {
              workAreaStore.activeBrand && this.state.brandColors.length ? (
                <div className='col-12 palette-col' style={{marginBottom: '10px'}}>
                  {
                    this.state.brandColors.map((color, idx) => {
                      return (
                        <ColorBlock
                          key={idx + color}
                          title={color.name}
                          colors={color.colors}
                          objName={idx}
                          onClick={this.selectProjectColor.bind(this)}
                        />
                      )
                    })
                  }
                </div>
              )
              :
              undefined
            }
            {
              showBrandPromo ? (
                <div className='col-12 brand-promo palette-col mt-3 mb-2'>
                  <div className='color-block-title-wrapper'>
                    <h5 className='color-block-title'>Brand palettes show up here</h5>
                  </div>
                  <div className='brand-promo_body'>
                    {
                      this.props.store.subscription ? (
                        <span className='brand-promo_text'>
                          Your account is eligible to use brand palettes. Choose a brand by clicking <button onClick={e => this.openBrandModal(e)} className='btn-none'>here</button> or <a href={`${this.getBrandPromoLink()}`}>Create a new brand</a>.
                        </span>
                      )
                      :
                      (
                        <span className='brand-promo_text'>
                          Upgrade your account by clicking <button onClick={e => this.openBrandModal(e)} className='btn-none'>here</button> to access brand palettes.
                        </span>
                      )
                    }
                  </div>
                </div>   
              )
              :
              undefined
            }
            {
              <div className='col-12 palette-col' style={{marginBottom: '10px'}}>
                <ColorBlock
                  title={'Default color palette'}
                  colors={this.state.defaultColors}
                  objName={'defaultColors'}
                  onClick={this.selectColorFromBlock.bind(this)}
                />
              </div>
            }
            <div className='col-12 bg-col' style={{paddingBottom: uploadAllowed ? '10%' : '0'}}>
              {uploadAllowed ? (
                <React.Fragment>
                  <h5 className='color-block-title' style={{marginBottom: '15px'}}>Set a custom page background</h5>
                  {
                    existingBackgound ? (
                      <div className='existing-bg'>
                        <CropIcon 
                          className='existing-bg__crop' 
                          onClick={() => this.openCropper()}
                        />
                        <TrashIcon 
                          className='existing-bg__delete' 
                          onClick={() => this.deleteBackground()}
                        />
                        <img 
                          className='existing-bg__display' 
                          src={existingBackgound}
                        />
                      </div>
                    )
                    :
                    undefined
                  }
                  <Upload
                    name='image' 
                    label={'Drag an image here that you want to upload as a background'}
                    customStyle={{
                      width: '95%',
                      margin: '2.5%',
                      marginTop: '10px'
                    }}
                    isBackground={uploadAllowed}
                    uploading={uploading}
                    progress={progress}
                    upload={this.uploadToServer.bind(this)}
                  />
                </React.Fragment>
              )
              : undefined}
            </div>
        </div>
      </div>
    )
  }


}

export default ColorSlide